import request from '@/api/request'
/**
 * 考试安排列表
 * @param page
 * @param limit
 */
export const getExamPlanListPage = (params) => {
  return request({
    url: 'radioweb/app/web/getExamPlanListPage',
    params,
    method: 'get'
  })
}
/**
 * 获取人才服务详情
 */
// export const getExamPlanListPage = (params) => {
//   return request({
//     url: 'radioweb/app/talentServe/getExamPlanListPage',
//     params,
//     method: 'get'
//   })
// }
